import {Component, OnInit, Inject, PLATFORM_ID, Renderer2, AfterViewInit} from '@angular/core';
import {DOCUMENT, isPlatformBrowser, isPlatformServer} from '@angular/common';
import * as $ from 'jquery';
import { interval } from 'rxjs';
import { TweenMax } from 'gsap';
import { Title } from '@angular/platform-browser';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-asistente-virtual',
  templateUrl: './asistente-virtual.component.html',
  styleUrls: ['./asistente-virtual.component.scss']
})
export class AsistenteVirtualComponent implements OnInit, AfterViewInit{
  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  constructor(
    private titleService: Title,
    private metaService:Meta,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document
  ) {
    this.loadScript();
  }

  ngOnInit(): void {
    this.titleService.setTitle('Asistente virtual - Centro de Ayuda');
    this.metaService.updateTag({ name: 'description', content: 'Contáctate de forma online con un ejecutivo comercial de Metrogas a través de una videollamada y resuelve todas tus dudas sobre tu boleta, saldos y otros productos y servicios relacionados a tu suministro de gas natural.' });

    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }
    }
    // Levantar chat
    // @ts-ignore
    $(document).ready(() => {
      // @ts-ignore
      setTimeout(() => { videsk.toggle(true); }, 1000);
    });
  }
  
  ngAfterViewInit(){
    //@ts-ignore
    $('.videsk-top-container').css('display','');
  }



  loadScript() {
    if (this.isBrowser) {
      const node = document.createElement('script');
      node.src = 'https://assets.videsk.io/js/videsk-widget.min.js';
      node.setAttribute('videsk-token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyYWMiOiI1ZjljNDAtYmM3YzUxLWYwMWFkYi1kMzUxOTgiLCJpYXQiOjE2MDQwNzU3MTF9.Cqhq2zEbR2M3tnsOGfWMuDiASjnhDsFKO8pN9WHsub4');
      document.getElementsByTagName('body')[0].appendChild(node);
      const show = document.createElement('script');
      show.innerHTML = 'window.onload = function(){ setTimeout(function(){console.log(videsk); videsk.toggle(true); }, 2000); };';
      document.getElementsByTagName('body')[0].appendChild(show);
    }
  }

  irHome() {
    location.href="./home";
  }
}
